import React from "react";

export const ICON_PATHS = {
  home: '<path d="M4 11L12 4l8 7"/><path d="M6 10v9h12v-9"/><path d="M10 19v-5h4v5"/>',
  clipboard:
    '<rect x="6" y="5" width="12" height="16" rx="2"/><path d="M9 5V4a1 1 0 011-1h4a1 1 0 011 1v1"/><path d="M9 11h6M9 15h6"/>',
  truck:
    '<rect x="2" y="8" width="12" height="8" rx="1"/><path d="M14 11h4l3 3v2h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
  activity: '<path d="M3 12h4l2 7 4-14 2 7h6"/>',
  inprogress: '<path d="M21 12a9 9 0 11-3-6.7"/><path d="M21 3v6h-6"/>',
  check: '<circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/>',
  bell:
    '<path d="M12 3a5 5 0 00-5 5v3l-2 4h14l-2-4V8a5 5 0 00-5-5z"/><path d="M9.5 19a2.5 2.5 0 005 0"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/>',
  chart: '<path d="M4 20V10M12 20V4M20 20v-7"/>',
  x: '<path d="M6 6l12 12M18 6L6 18"/>',
  phone:
    '<path d="M5 4h3l2 5-2 1a11 11 0 006 6l1-2 5 2v3a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2z"/>',
  msg: '<path d="M4 4h16v11H8l-4 4z"/>',
  alert: '<path d="M12 3l9.5 17H2.5z"/><path d="M12 9.5v4.5M12 17h.01"/>',
  note: '<path d="M6 4h9l4 4v12H6z"/><path d="M15 4v4h4"/><path d="M9 12h6M9 16h6"/>',
  reply: '<path d="M9 5l-5 5 5 5"/><path d="M4 10h9a6 6 0 016 6v2"/>',
  sparkle:
    '<path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6z"/><path d="M19 15l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  calendar:
    '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/>',
  book:
    '<path d="M4 5.5A1.5 1.5 0 015.5 4H11a2 2 0 012 2v14a2 2 0 00-2-1H5.5A1.5 1.5 0 014 17.5v-12z"/><path d="M20 5.5A1.5 1.5 0 0018.5 4H13a2 2 0 00-2 2v14a2 2 0 012-1h5.5a1.5 1.5 0 001.5-1.5v-12z"/>',
  external: '<path d="M14 3h7v7"/><path d="M10 14L21 3"/><path d="M21 14v7H3V3h7"/>',
  chevronDown: '<path d="M6 9l6 6 6-6"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',
};

/** Inline svg icon, identical markup to the prototype's icon() helper. */
export const Icon = ({ name, cls = "", style }) => (
  <svg
    className={`icon ${cls}`.trim()}
    viewBox="0 0 24 24"
    style={style}
    dangerouslySetInnerHTML={{ __html: ICON_PATHS[name] || "" }}
  />
);

/** String form, for the few places the prototype embeds an icon inside markup. */
export const iconHTML = (name, cls) =>
  `<svg class="icon ${cls || ""}" viewBox="0 0 24 24">${ICON_PATHS[name] || ""}</svg>`;
